import { getFormattedPrice } from 'Components/ContractGenerator/shared/helpers/priceHelpers';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import { getValidatedPriceInput } from 'Shared/helpers/priceHelpers';
import Input from 'ViatoUi/Web/FormElements/Inputs/Input';

const Value = ({ label, option, optionId, productId, type, isSetupFee }) => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');

	const dataToSubmit = useSelector(contractGeneratorSelectors.getDiscountDataToSubmit);

	const translationPath = 'layouts.share.modals.createLink.linkSettings.setting.value';

	const typeDefaultValue = isSetupFee ? option.setupFee.discount.type : option.discount.type;
	const typeObjectPath = `${type}.${productId}.${optionId}.${isSetupFee ? 'setupFee.' : ''}discount.type`;
	const discountType = get(dataToSubmit, typeObjectPath, typeDefaultValue);

	const defaultValue = isSetupFee ? option.setupFee.discount.value : option.discount.value;
	const objectPath = `${type}.${productId}.${optionId}.${isSetupFee ? 'setupFee.' : ''}discount.value`;
	const value = get(dataToSubmit, objectPath, defaultValue);

	const validate = newValue => {
		if (String(newValue).endsWith('.')) {
			return {
				isValid: false,
				errorMessages: [t(`${translationPath}.errorMessages.cantEndWithDot`)],
				label,
				showErrorMessage: true
			};
		}

		if (String(newValue) === '') {
			return {
				isValid: false,
				errorMessages: [t(`${translationPath}.errorMessages.cantBeEmpty`)],
				label,
				showErrorMessage: true
			};
		}

		return {
			isValid: true
		};
	};

	const setFieldInfo = data => {
		let preparedData = data;
		if (isSetupFee) {
			preparedData = { setupFee: data };
		}
		dispatch(
			contractGeneratorOperations.setDiscountFieldInfo({
				[type]: {
					[productId]: {
						[optionId]: preparedData
					}
				}
			})
		);
	};

	const setDataToSubmit = data => {
		let preparedData = data;
		if (isSetupFee) {
			preparedData = { setupFee: data };
		}
		dispatch(
			contractGeneratorOperations.setDiscountDataToSubmit({
				[type]: {
					[productId]: {
						[optionId]: preparedData
					}
				}
			})
		);
	};

	useEffect(() => {
		setFieldInfo({
			discount: {
				value: validate(0)
			}
		});

		setDataToSubmit({
			discount: {
				value: 0
			}
		});
	}, [discountType]);

	return (
		<Input
			placeholder={`${isSetupFee ? t(`${translationPath}.setup`) : t(`${translationPath}.monthly`)} ${
				discountType !== 'percentage' && value > 0 ? `(= ${getFormattedPrice(value / 100)} €)` : ''
			}`}
			value={value}
			onChange={newValue => {
				setFieldInfo({
					discount: {
						value: validate(getValidatedPriceInput(newValue, value, { allowDecimals: discountType === 'percentage' }))
					}
				});

				setDataToSubmit({
					discount: {
						value: getValidatedPriceInput(newValue, value, { allowDecimals: discountType === 'percentage' })
					}
				});
			}}
		/>
	);
};

Value.propTypes = {
	label: PropTypes.string.isRequired,
	isSetupFee: PropTypes.bool.isRequired,
	option: PropTypes.object.isRequired,
	optionId: PropTypes.number.isRequired,
	productId: PropTypes.number.isRequired,
	type: PropTypes.oneOf(['products', 'extensions']).isRequired
};

export default Value;
